import React from 'react';
import { PropTypes as PT } from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';
import _get from 'lodash/get';
import { ReactComponent as StarIcon } from '@lifesize/ux-assets/vectors/svgIcons/star.svg';
import { ReactComponent as StarOutlineIcon } from '@lifesize/ux-assets/vectors/svgIcons/star-outline.svg';
import Tooltip from 'components/Tooltip/Tooltip';

class FavoriteStar extends React.Component {
  onToggleFavorites = (event) => {
    event.stopPropagation();
    this.props.handleFavoriteToggle(this.props.contact.uuid, !this.props.contact.favorite);
  };

  render() {
    const { contact, favClassName } = this.props;
    if (!_get(contact, 'isFavoritable')) return <div />;

    const favoriteTooltip = contact.favorite ? (
      <FormattedMessage id="components.contacts.favorite.tooltip.remove" defaultMessage="Remove Favorite" />
    ) : (
      <FormattedMessage id="components.contacts.favorite.tooltip.add" defaultMessage="Add Favorite" />
    );

    return (
      <span className={favClassName}>
        {contact.favorite ? (
          <button onClick={this.onToggleFavorites} data-testid="card-remove-favorite">
            <StarIcon data-testid="star-icon" />
          </button>
        ) : (
          <button onClick={this.onToggleFavorites} data-testid="card-add-favorite">
            <StarOutlineIcon data-testid="star-outline-icon" />
          </button>
        )}
        <Tooltip fixPosition style={this.props.tooltipStyle} label={favoriteTooltip} />
      </span>
    );
  }
}

FavoriteStar.propTypes = {
  intl: PT.object,
  tooltipStyle: PT.object,
  contact: PT.object.isRequired,
  handleFavoriteToggle: PT.func,
  favClassName: PT.string
};

FavoriteStar.defaultProps = {
  tooltipStyle: { top: '32px' }
};

export default injectIntl(FavoriteStar);
